import React from "react";
import { useNavigate } from "react-router-dom";

function Categories() {
  const Categories = [
    {
      id: 1,
      image: "assets/images/thumbs/web-development.png",
      gif: "assets/img/c1.gif",
      title: "Web Development",
      link: "/course-list",
    },
    {
      id: 2,
      image: "assets/images/thumbs/web-design.png",
      gif: "assets/img/c2.gif",
      title: "Web Designing",
      link: "/course-list",
    },
    {
      id: 3,
      image: "assets/images/thumbs/data-science.png",
      gif: "assets/img/c3.gif",
      title: "Data Science",
      link: "/course-list",
    },
    {
      id: 4,
      image: "assets/images/thumbs/ai.png",
      gif: "assets/img/c4.gif",
      title: "Artificial Intelligence",
      link: "/course-list",
    },
    {
      id: 5,
      image: "assets/images/thumbs/cloud-computing.png",
      gif: "assets/img/c5.gif",
      title: "Cloud Computing",
      link: "/course-list",
    },
    {
      id: 6,
      image: "assets/images/thumbs/database.png",
      gif: "assets/img/c6.gif",
      title: "Database",
      link: "/course-list",
    },
    {
      id: 7,
      image: "assets/images/thumbs/software-testing.png",
      gif: "assets/img/c7.gif",
      title: "Software Testing",
      link: "/course-list",
    },
    {
      id: 8,
      image: "assets/images/thumbs/data-analytics.png",
      gif: "assets/img/c9.gif",
      title: "Data Analytics",
      link: "/course-list",
    },
    {
      id: 9,
      image: "assets/images/thumbs/mobile-app.png",
      gif: "assets/img/c10.gif",
      title: "Mobile App",
      link: "/course-list",
    },
    {
      id: 10,
      image: "assets/images/thumbs/cyber-security.png",
      gif: "assets/img/c11.gif",
      title: "Cyber Security",
      link: "/course-list",
    },
  ];

  const navigate = useNavigate();

  const handleCategoryClick = (category) => {
    navigate("/course-list", { state: { selectedCategory: category.title } });
  };

  return (
    <div className="container">
      <section className="team-section padding">
        <div className="row gy-lg-0 gy-4">
          {Categories.map((category, index) => (
            <div key={category.id} className="col-lg-3 col-md-6">
              <div className="team-item wow fade-in-bottom" data-wow-delay={`${100 * (index + 1)}ms`} style={{ marginBottom: "40px" }}>
                <div className="team-thumb" onClick={() => handleCategoryClick(category)} style={{cursor: "pointer"}}>
                  <img src={category.gif} alt={`${category.title} thumbnail`} />
                </div>
                <div className="team-content">
                  <h3>
                    <a  onClick={() => handleCategoryClick(category)}  style={{cursor: "pointer" ,color:"#FF001E"}}>{category.title}</a>
                  </h3>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default Categories;
